import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CheckIcon from '@mui/icons-material/Check';
import { useLocations } from '../hooks/useLocations';
// ── Farm Switcher ──────────────────────────────────────────────────────────────
export const FarmSwitcher = () => {
    const { locations, selectedLocation, setSelectedLocation, loading } = useLocations();
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);
    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);
    const handleSelect = (loc) => {
        setSelectedLocation(loc);
        setOpen(false);
    };
    if (loading || !selectedLocation)
        return null;
    return (_jsxs(Box, { ref: containerRef, sx: { position: 'relative' }, children: [_jsxs(ButtonBase, { onClick: () => setOpen((prev) => !prev), sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '999px',
                    '&:hover': { bgcolor: 'grey.100' },
                    transition: 'background 0.15s',
                }, disableRipple: false, children: [_jsx(Typography, { variant: "body2", sx: {
                            fontWeight: 700,
                            color: 'primary.main',
                            lineHeight: 1,
                            display: { xs: 'none', sm: 'block' },
                        }, children: selectedLocation.name }), _jsx(KeyboardArrowDownIcon, { sx: {
                            fontSize: 16,
                            color: 'primary.main',
                            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s',
                        } })] }), open && (_jsx(Paper, { elevation: 4, sx: {
                    position: 'absolute',
                    top: 'calc(100% + 8px)',
                    right: 0,
                    minWidth: 200,
                    borderRadius: 2,
                    overflow: 'hidden',
                    zIndex: 1300,
                    border: '1px solid',
                    borderColor: 'divider',
                }, children: locations.map((farm, idx) => {
                    const isSelected = selectedLocation.locationId === farm.locationId;
                    return (_jsxs(ButtonBase, { onClick: () => handleSelect(farm), sx: {
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            px: 2,
                            py: 1,
                            textAlign: 'left',
                            borderBottom: idx < locations.length - 1 ? '1px solid' : 'none',
                            borderColor: 'grey.100',
                            '&:hover': { bgcolor: 'grey.50' },
                            transition: 'background 0.15s',
                        }, children: [_jsx(Typography, { variant: "body2", sx: {
                                    flex: 1,
                                    fontWeight: isSelected ? 700 : 500,
                                    color: isSelected ? 'primary.main' : 'text.primary',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }, children: farm.name }), _jsxs(Typography, { variant: "caption", sx: { color: 'text.secondary', flexShrink: 0, whiteSpace: 'nowrap' }, children: [farm.pondCount, " ponds"] }), isSelected && (_jsx(CheckIcon, { sx: {
                                    fontSize: 14,
                                    color: 'primary.main',
                                    flexShrink: 0,
                                } }))] }, farm.locationId));
                }) }))] }));
};
